/**
 * Trellis API client for calling edge functions.
 * All routes are typed via the Api registry.
 *
 * Usage:
 *   import { api } from '../lib/api'
 *   const result = await api.aiLabel.fetch({ imageUrl: '...' })
 */
import { createApiClient, TrellisError } from '@fliisi/trellis'
import type { Api } from '@fliisi/trellis'
import { supabase } from './supabase'

const SUPABASE_URL = process.env.EXPO_PUBLIC_SUPABASE_URL || 'https://bxyhzvtycfdahafnmpjz.supabase.co'
const SUPABASE_ANON_KEY = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || ''

// Cache the access token so the synchronous headers() callback can use it
let cachedToken = ''

// Keep token fresh via auth state changes
supabase.auth.onAuthStateChange((_event, session) => {
  cachedToken = session?.access_token || ''
})

// Also prime on init
supabase.auth.getSession().then(({ data: { session } }) => {
  cachedToken = session?.access_token || ''
})

export const api = createApiClient<Api>({
  baseUrl: `${SUPABASE_URL}/functions/v1`,
  headers: () => ({
    'Authorization': cachedToken ? `Bearer ${cachedToken}` : '',
    'apikey': SUPABASE_ANON_KEY,
  }),
})

export { TrellisError }
